module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/map_stay-7bd36c6bd4135559b4e297c43300d723.png";